import React from 'react';

const Error = () => {
    return (
        <div className="info-box">No servers to compare. Add at least two servers to compare. <a href="/hardware/soundgrid-servers" className="underline">Back to Servers List.</a></div>
    )
};

export default Error;